import ButtonBase from "@mui/material/ButtonBase";
import SvgIcon from "@mui/material/SvgIcon";
import { grey } from "@mui/material/colors";
import ChevronLeftIcon from "./icons/ChevronLeftIcon";
import ChevronRightIcon from "./icons/ChevronRightIcon";

export default function ShowHideSidebarButton({
  theme,
  onClick,
  sidebarClosed,
}) {
  const button = {
    zIndex: "75",
    width: "2rem",
    height: "3.5rem",
    borderRadius: "0 0.375rem 0.375rem 0",
    backgroundColor: grey[700],
    position: "absolute",
    top: "0",
    bottom: "0",
    margin: "auto 0",
    left: sidebarClosed ? "auto" : "90%",
    [theme.breakpoints.up("md")]: {
      right: sidebarClosed ? "0" : "-2rem",
      left: sidebarClosed ? "0" : "auto",
    },
    transition: "background-color .2s ease-in-out",
    "&:hover": {
      backgroundColor: grey[600],
    },
  };

  return (
    <ButtonBase onClick={onClick} sx={button}>
      <SvgIcon sx={{ color: "white" }}>
        {sidebarClosed ? (
          <ChevronRightIcon sx={{ color: "white" }} />
        ) : (
          <ChevronLeftIcon sx={{ color: "white" }} />
        )}
      </SvgIcon>
    </ButtonBase>
  );
}
